"use client";

import {motion} from "framer-motion";
import {Quote} from "lucide-react";
import {useTranslations} from "next-intl";
import {useState} from "react";

export function TestimonialsCarousel() {
  const t = useTranslations("testimonials");
  const [index, setIndex] = useState(0);

  const testimonials = [1, 2, 3].map((item) => ({
    quote: t(`items.${item}.quote`),
    author: t(`items.${item}.author`),
  }));

  const next = () => setIndex((prev) => (prev + 1) % testimonials.length);
  const prev = () => setIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);

  return (
    <section className="clinic-section mx-auto max-w-7xl px-4 py-16 sm:px-6 md:py-24 lg:px-8">
      <div className="rounded-[2rem] border border-[#173b35]/10 bg-[#dcebe6] p-6 md:p-9 dark:border-white/10 dark:bg-[#173b35]">
        <p className="clinic-eyebrow">
          {t("eyebrow")}
        </p>
        <h2 className="clinic-display clinic-heading">
          {t("title")}
        </h2>

        <motion.blockquote
          key={testimonials[index].quote}
          initial={{opacity: 0, y: 12}}
          animate={{opacity: 1, y: 0}}
          transition={{duration: 0.25, ease: "easeOut"}}
          className="mt-8 rounded-2xl border border-[#173b35]/8 bg-[#fffefa] p-6 shadow-[0_18px_45px_-34px_rgba(23,59,53,0.5)] dark:border-white/10 dark:bg-white/6"
        >
          <Quote className="h-6 w-6 text-[#c95f4b]" aria-hidden />
          <p className="clinic-display mt-4 max-w-4xl text-xl leading-8 text-[var(--clinic-ink-soft)]">{testimonials[index].quote}</p>
          <footer className="mt-4 text-sm font-semibold text-[var(--clinic-ink)]">
            {testimonials[index].author}
          </footer>
        </motion.blockquote>

        <div className="mt-5 flex items-center gap-3">
          <button
            type="button"
            onClick={prev}
            className="min-h-11 rounded-full border border-[var(--clinic-line-strong)] bg-white/40 px-5 text-sm font-semibold text-[var(--clinic-ink-soft)] hover:border-[var(--clinic-line-strong)] hover:bg-white/70 dark:border-white/20 dark:hover:bg-white/10"
          >
            {t("previous")}
          </button>
          <button
            type="button"
            onClick={next}
            className="min-h-11 rounded-full bg-[var(--clinic-brand)] px-5 text-sm font-semibold text-white hover:bg-[var(--clinic-brand-hover)]"
          >
            {t("next")}
          </button>
        </div>
      </div>
    </section>
  );
}
